var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pega-table grid-x margin-bottom-1" },
    [
      _c(
        "div",
        { staticClass: "cell title" },
        [_vm._v("\n    " + _vm._s(_vm.title)), _vm._t("title")],
        2
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }